const QuestionStrips = {
  init() {
    if (!($('.question-strip').length > 0)) return;

    $('.question-strip .section-box').focus(this.handleInputterFocus.bind(this));
    $('.question-strip .nexter').click(this.handleNexterClick.bind(this));
    $('.question-strip .jumper').click(this.handleJumperClick.bind(this));
  },

  handleInputterFocus(event) {
    $('.section-box').removeClass('visible');
    const box = $(event.target).closest('.section-box');
    box.addClass('visible');
    $('html,body').animate({
       scrollTop: box.offset().top - 150
    });
  },

  handleNexterClick(event) {
    const box = $(event.target).closest('.section-box');
    const nextBox = box.next()
    nextBox.focus();
  },

  handleJumperClick(event) {
    const button = $(event.target).closest('.jumper');
    const nextBox = $(button.data('destination'));
    nextBox.focus();
  },
};

$(document).ready(()=> {
  QuestionStrips.init();
});
